var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.514,
    height: 66,
    viewBox: "0 0 68.514 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5893",
    "data-name": "Group 5893",
    transform: "translate(-207.999 -184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    d: "M117.562,16.27S100.211,32.319,100.211,35.4s14.233-4.985,12.336,0S92.6,55.347,92.6,55.347",
    transform: "translate(134.539 179.561)",
    fill: "none",
    stroke: "#8176f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M120.873,9.167a31.9,31.9,0,0,0-44.746,0,31.152,31.152,0,0,0,0,44.31A31.624,31.624,0,0,0,97.548,62.62a2.094,2.094,0,0,0,.432.052h30.126a2,2,0,0,0,1.429-.589,2.035,2.035,0,0,0,.6-1.415,2.008,2.008,0,0,0-2.016-2H98.3a1.655,1.655,0,0,0-.268-.029A27.6,27.6,0,0,1,79,50.655,27.178,27.178,0,0,1,79,12a27.828,27.828,0,0,1,39.032,0A27.022,27.022,0,0,1,126.1,31.329V36.98a2.024,2.024,0,0,0,3.445,1.422,1.99,1.99,0,0,0,.6-1.415V31.337a30.97,30.97,0,0,0-9.256-22.155Z",
    transform: "translate(141.124 183.995)",
    fill: "#00a2a4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 5.484,
    cy: 5.484,
    r: 5.484,
    transform: "translate(265.546 239.033)",
    fill: "#00a2a4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2997b524ab2d61e9dce7994b7ef13911.svg";
export { ForwardRef as ReactComponent };